/**
 * Escape a plain-text string for safe interpolation into an HTML string.
 *
 * Use this whenever user-controlled text (vehicle names, route names,
 * addresses, etc.) is placed into a raw HTML string that will be rendered
 * outside React's auto-escaping — e.g. Leaflet `bindTooltip` / `L.divIcon`
 * HTML, or any manual `innerHTML`. React JSX already escapes text, so this is
 * NOT needed for values rendered as JSX children.
 *
 * Escapes the five HTML-significant characters (`&`, `<`, `>`, `"`, `'`).
 * `&` must be replaced first so already-escaped entities are not double-broken.
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
